import { EmptyContent } from '@cosuno/cosuno-ui';
import styled from 'styled-components';

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-template-rows: repeat(3, auto);
  gap: 30px;
`;

export const StyledEmptyContent = styled(EmptyContent)`
  padding-bottom: 0;
`;
